export function XML_Param4(paramID, param1, param2, param3, param4, xmlCanvas) {
  var s = xmlCanvas.GetStream();
  xmlCanvas.OutputElementQuad(paramID, param1, param2, param3, param4, s);
}
